import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IDynamicComponent } from 'src/app/shared/models/dynamic-component-loader/IDynamicComponent.model';

@Component({ 
  selector: 'terra-multi-checkbox',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule],
  template: `
    <div *ngFor="let checkbox of data.checkboxes; let i = index">
      @if (checkbox.display !== false) {
        <mat-checkbox
          color="primary"
          [checked]="checkbox.checked"
          [disabled]="checkbox.disabled"
          (change)="onChange($event, checkbox)"
        >
          {{checkbox.label}}
        </mat-checkbox>
      }
    </div>
  `,
  styles: `:host { display: block; }`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiCheckboxComponent implements IDynamicComponent {
  @Input() data: any;

  onChange(event?: any, checkbox?: any) {
    if (event && checkbox) {
      checkbox.checked = event.checked;
    }
    if (this.data && typeof this.data.output === 'function') {
      this.data.output(this.data.checkboxes.map(cb => cb.checked));
    }
  }
}
